// extracted by mini-css-extract-plugin
export default {"main-content":"UttamKalakarHeader_main-content__KPF7h","header-image":"UttamKalakarHeader_header-image__CYDij"};